import * as React from "react";
import { useProvider } from "../Context";

const initialState = {
  isError: false,
  errorMsg: "",
};

function reducer(state, { type, payload }) {
  switch (type) {
    case "set":
      return { ...state, ...payload };
    default:
      throw new Error("Action type not found");
  }
}

export function useErrorReducer() {
  const [state, dispatch] = React.useReducer(reducer, initialState);
  return {
    state,
    dispatch,
  };
}

export default function () {
  const {
    auth: { state, dispatch },
  } = useProvider();

  function initialize() {
    dispatch({ 
      type: "set", 
      payload: { 
        isError: false,
        errorMsg: "" 
      } 
    });
  }

  return {
    state: state,
    dispatch: dispatch,
    initialize,
  };
}
